/* ==========================================================================
   MG PRODUCT
   - Image slider for mg-product-main (one image per view, looping arrows, swipe)
   - Option pills: pick the matching variant, update the hidden variant id and URL
   ========================================================================== */
(function () {
  'use strict';

  function mgInitGallery(mgRoot) {
    var mgWrap = mgRoot.querySelector('[data-mg-gallery]');
    if (!mgWrap || mgWrap.dataset.mgReady) return;
    mgWrap.dataset.mgReady = 'true';
    var mgTrack = mgWrap.querySelector('[data-mg-gallery-track]');
    var mgSlides = mgTrack ? mgTrack.querySelectorAll('[data-mg-gallery-slide]') : [];
    if (mgSlides.length < 2) return;
    var mgIndex = 0;

    function mgGo(mgI) {
      mgIndex = (mgI + mgSlides.length) % mgSlides.length;
      mgTrack.style.transform = 'translate3d(' + (-100 * mgIndex) + '%, 0, 0)';
    }

    var mgPrev = mgWrap.querySelector('[data-mg-gallery-prev]');
    var mgNext = mgWrap.querySelector('[data-mg-gallery-next]');
    if (mgPrev) mgPrev.addEventListener('click', function () { mgGo(mgIndex - 1); });
    if (mgNext) mgNext.addEventListener('click', function () { mgGo(mgIndex + 1); });

    var mgX = null;
    mgTrack.addEventListener('touchstart', function (mgE) { mgX = mgE.touches[0].clientX; }, { passive: true });
    mgTrack.addEventListener('touchend', function (mgE) {
      if (mgX === null) return;
      var mgDx = mgE.changedTouches[0].clientX - mgX;
      if (Math.abs(mgDx) > 40) mgGo(mgIndex + (mgDx < 0 ? 1 : -1));
      mgX = null;
    });

    mgRoot.mgGoToMedia = function (mgMediaId) {
      for (var mgK = 0; mgK < mgSlides.length; mgK++) {
        if (String(mgSlides[mgK].dataset.mgMediaId) === String(mgMediaId)) { mgGo(mgK); return; }
      }
    };
  }

  function mgInitOptions(mgRoot) {
    var mgJson = mgRoot.querySelector('[data-mg-variants]');
    if (!mgJson || mgRoot.dataset.mgOptionsReady) return;
    mgRoot.dataset.mgOptionsReady = 'true';
    var mgVariants = [];
    try { mgVariants = JSON.parse(mgJson.textContent); } catch (e) { return; }

    // 'click' (not 'change') so a pill that is already selected still slides to its image
    mgRoot.addEventListener('click', function (mgE) {
      if (!mgE.target.matches('[data-mg-option]')) return;
      var mgSelected = [];
      mgRoot.querySelectorAll('[data-mg-option]:checked').forEach(function (mgInput) {
        mgSelected[parseInt(mgInput.dataset.mgOption, 10)] = mgInput.value;
      });
      var mgMatch = mgVariants.find(function (mgV) {
        return mgV.options.every(function (mgO, mgI) { return mgSelected[mgI] === undefined || mgSelected[mgI] === mgO; });
      });
      if (!mgMatch) return;
      var mgId = mgRoot.querySelector('[data-mg-variant-id]');
      if (mgId) mgId.value = mgMatch.id;
      var mgUrl = new URL(window.location.href);
      mgUrl.searchParams.set('variant', mgMatch.id);
      window.history.replaceState({}, '', mgUrl.toString());
      if (mgMatch.featured_media && mgRoot.mgGoToMedia) mgRoot.mgGoToMedia(mgMatch.featured_media.id);
    });
  }

  // Page-load color sweep (section + wave strip)
  function mgInitIntro(mgScope) {
    var mgEls = (mgScope || document).querySelectorAll('.mg-pmain-bg--intro:not(.mg-is-loaded)');
    if (!mgEls.length) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        mgEls.forEach(function (mgEl) { mgEl.classList.add('mg-is-loaded'); });
      });
    });
  }

  function mgInitAll(mgScope) {
    (mgScope || document).querySelectorAll('[data-mg-product]').forEach(function (mgRoot) {
      mgInitGallery(mgRoot);
      mgInitOptions(mgRoot);
    });
    mgInitIntro(mgScope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mgInitAll(); });
  } else {
    mgInitAll();
  }
  document.addEventListener('shopify:section:load', function (mgE) { mgInitAll(mgE.target); });
})();
